export default __webpack_public_path__ + "static/media/logo2.2de6f284.png";